var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCoffee = function SvgCoffee(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1177",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M66.768 7.276h225.61c13.334 0 24.168 10.948 24.168 24.275v54.262H42.486V31.55c0-13.328 10.953-24.275 24.287-24.275zm249.78 301.66c1.548 25.465-9.167 39.03-34.05 38.317H73.078c-22.263-1.547-31.192-15.47-30.597-38.317z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1179",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M70.459 96.999h220.01v201.22H70.459zm148.7 116.38h8.215c8.334 0 15.358 7.02 15.358 15.351v2.142c0 8.449-7.024 15.35-15.358 15.35h-8.215v5.237c0 16.898-13.929 30.7-30.716 30.7h-28.811c-16.906 0-30.716-13.803-30.716-30.7v-46.41h90.244v8.45m-99.054-98.41h110.01v24.87h-14.287V163.4h-23.811v-23.8h-29.883v23.443H138.8V139.72h-18.692z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCoffee);
export default ForwardRef;